module.exports = __webpack_public_path__ + "static/media/bulletins.38daa006.svg";